module.exports = __webpack_public_path__ + "static/media/portlinkLogolg.e0624631.svg";